function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#2BA6D9",
  d: "M7.6,0.6c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S11.5,0.6,7.6,0.6z M7.6,13.8c-3.4,0-6.1-2.8-6.1-6.1                               s2.8-6.1,6.1-6.1c3.4,0,6.2,2.8,6.2,6.1S11,13.8,7.6,13.8z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 7.1,
  y: 4.4,
  fill: "#2BA6D9",
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 7.1,
  y: 6.4,
  fill: "#2BA6D9",
  width: 1,
  height: 5
}));

var SvgVirtualizationBootmenu = function SvgVirtualizationBootmenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("span", {
    className: "info_icon",
    "data-toggle": "tooltip",
    title: "",
    "data-original-title": "Enable BIOS boot menu during VM startup"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.2 15.2",
    style: {
      enableBackground: "new 0 0 15.2 15.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVirtualizationBootmenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/virtualization_bootmenu.6f5925a0.svg";
export { ForwardRef as ReactComponent };